import React, { useEffect, useRef, useState, useMemo } from 'react'
import Slides from '../slides/Slides'
import AutocompleteContrato from '../resource/AutocompleteContrato';
import { WebService } from '../../services/webService';
import { Link } from 'react-router-dom';
import { FaDownload } from 'react-icons/fa';
import Swal from 'sweetalert2';
import loading from "../../js/loading";

const Credenciales = ({ M }) => {
   const [contratos, setContratos]                             = useState([]);
   const [nominaEmpleados, setNominaEmpleados]                 = useState([]);
   const [nominaEmpleadosChecked, setNominaEmpleadosChecked]   = useState([]);
   const [checkedAll, setCheckedAll]                           = useState(false);
   const [searchContrato, setSearchContrato]                   = useState("");
   const [searchEmpleado, setSearchEmpleado]                   = useState(""); // Nuevo estado para buscar empleado por nombre
   const iContratoRef                                          = useRef(null);
   const [contratoID, setContratoID]                           = useState();

   const getContratosActivos = async () => {
      try {
         const data = await WebService.getContratosActivos();
         setContratos(data);
      } catch (error) {
         console.error("Error al cargar los padrones activos:", error);
      }
   };

   // Limpiar el buscador de empleados cuando cambia la nómina principal (nuevo contrato seleccionado)
   useEffect(() => {
      setSearchEmpleado("");
      setCheckedAll(false);
   }, [contratoID]);

   // Filtro optimizado para la nómina de empleados por nombre o apellido
   const filteredNominaEmpleados = useMemo(() => {
      if (!searchEmpleado) return nominaEmpleados;
      return nominaEmpleados.filter((n) =>
         n.nomina_nombre?.toLowerCase().includes(searchEmpleado.toLowerCase())
      );
   }, [nominaEmpleados, searchEmpleado]);

   const handleChecked = (e, apellidoNombre, cuil) => {
      const { id, checked } = e.target;
      setCheckedAll(false);
      // 1. Actualizamos la lista principal (el checkbox visual)
      setNominaEmpleados((prev) =>
         prev.map((n) => (n.nomina_id === id ? { ...n, checked } : n)),
      );
      // 2. Actualizamos el array de seleccionados
      setNominaEmpleadosChecked((prev) => {
         if (checked) {
            const nuevoEmpleado = { nomina_id: id, apellidoNombre, cuil };
            return [...prev, nuevoEmpleado];
         } else {
            return prev.filter((n) => n.nomina_id !== id);
         }
      });
   };

   const handleAllChecked = (e) => {
      const { checked } = e.target;
      setCheckedAll(checked);
      // Si hay un filtro activo, marcamos/desmarcamos solo los filtrados, o todos según prefieras. 
      // Aquí aplicamos sobre los elementos actualmente visibles (filteredNominaEmpleados)
      const idsVisibles = new Set(filteredNominaEmpleados.map(n => n.nomina_id));

      setNominaEmpleados((prev) => 
         prev.map((n) => idsVisibles.has(n.nomina_id) ? { ...n, checked } : n)
      );

      if (checked) {
         const seleccionadosVisibles = filteredNominaEmpleados.map((n) => ({
            nomina_id: n.nomina_id,
            apellidoNombre: n.nomina_nombre,
            cuil: n.nomina_cuil,
         }));
         // Unimos sin duplicar con los que ya estaban seleccionados de otros filtros
         setNominaEmpleadosChecked((prev) => {
            const map = new Map(prev.map(item => [item.nomina_id, item]));
            seleccionadosVisibles.forEach(item => map.set(item.nomina_id, item));
            return Array.from(map.values());
         });
      } else {
         setNominaEmpleadosChecked((prev) => 
            prev.filter(item => !idsVisibles.has(item.nomina_id))
         );
      }
   };

   const downloadCertificado = async (tipo, empleado = null) => {
      let payload;
      if (tipo === "credencial") {
         payload = empleado;
      } else {
         if (nominaEmpleadosChecked.length === 0) {
            return Swal.fire({
               icon: "warning",
               title: "Atención",
               text: "Seleccione al menos un empleado",
            });
         }
         payload = { nominaEmpleadosChecked };
      }

      try {
         loading.startLoading();
         const res = await WebService.generarCertificado(tipo, contratoID, payload);
         Swal.fire({
            icon: res.icon,
            title: res.title,
            html: res.message,
            confirmButtonColor: "#147B9C",
         });
      } catch (error) {
         console.error("Error al generar:", error);
      }
   };

   useEffect(() => {
      getContratosActivos();
   }, []);

   return (
      <>
         <Slides M={M} tipoSlides={"credenciales"}></Slides>
         <div className="section animated fadeIn">
            <div className="row center">
               <h5 className="light-blue-text text-accent-3">CREDENCIALES DIGITALES ART</h5>
               <div className="container">
                  <div className="row center">
                     <AutocompleteContrato 
                        contratos         =  {contratos} 
                        setData           =  {setNominaEmpleados} 
                        iContratoRef      =  {iContratoRef} 
                        searchContrato    =  {searchContrato}
                        setSearchContrato =  {setSearchContrato}
                        M                 =  {M}
                        setContratoID     =  {setContratoID}
                     />
                     <div className="input-field col s12 m2 l2 x2">
                        <Link id="impCred" className="btn btn-md btn-latitud impCred" title="Seleccionados" onClick={() => downloadCertificado("credenciales")}>
                           <i className="icono icon-print"></i>Imprimir
                        </Link>
                     </div>
                  </div>

                  {/* NUEVO: Input de búsqueda de empleado por nombre */}
                  <div className="row">
                     <div className="input-field col s12 m6 l6 offset-m3 offset-l3">
                        <input 
                           type="text" 
                           id="searchEmpleado"
                           className="form-control"
                           placeholder="BUSCAR EMPLEADO POR NOMBRE"
                           value={searchEmpleado}
                           onChange={(e) => setSearchEmpleado(e.target.value)}
                           autoComplete="off"
                           disabled={nominaEmpleados.length === 0}
                        />
                        <label htmlFor="searchEmpleado" className="active">Filtrar por Nombre o Apellido</label>
                     </div>
                  </div>

                  <div className="row">
                     <div className="table-responsive height-table-scroll">
                        <table className="centered striped responsive-table">
                           <thead>
                              <tr>
                                 <th scope="col">
                                    <label>
                                       <input type="checkbox" className="check" id="checkAll" onChange={(e) => handleAllChecked(e)} checked={checkedAll} />
                                       <span></span>
                                    </label>
                                 </th>
                                 <th scope="col">ORDEN</th>
                                 <th scope="col">APELLIDO Y NOMBRE</th>
                                 <th scope="col">CUIT</th>
                                 <th scope="col">PERIODO</th>
                                 <th scope="col">ACTIVIDAD</th>
                                 <th scope="col">IMPRIMIR</th>
                              </tr>
                           </thead>
                           <tbody className="center">
                              {
                                 filteredNominaEmpleados.length === 0 ? (
                                    <tr>
                                       <td colSpan="7" className="text-center">No se encontraron registros para esta búsqueda.</td>
                                    </tr>
                                 ) : (
                                    filteredNominaEmpleados.map((ne) => (
                                       <tr key={ne.nomina_id}>
                                          <td>
                                             <label>
                                                <input 
                                                   className="check" 
                                                   id={ne.nomina_id} 
                                                   onChange={(e) => handleChecked(e, ne.nomina_nombre, ne.nomina_cuil)} 
                                                   type="checkbox" 
                                                   checked={!!ne.checked} 
                                                />
                                                <span></span>
                                             </label>
                                          </td>
                                          <td>{ne.orden}</td>
                                          <td>{ne.nomina_nombre}</td>
                                          <td>{ne.nomina_cuil}</td>
                                          <td>{ne.nomina_padron_periododeclarado}</td>
                                          <td>
                                             <div className="tooltip-info" title={ne.actividad_desc_r4}>
                                                {ne.actividad_ciiur4}
                                             </div>
                                          </td>
                                          <td>
                                             <Link onClick={() => downloadCertificado('credencial', ne)}>
                                                <FaDownload />
                                             </Link>
                                          </td>
                                       </tr>
                                    ))
                                 )
                              }
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Credenciales;